module.exports = __webpack_public_path__ + "static/media/favicon01.ef01c22e.webp";